import { environmentURLs } from '../../common/environment/CaptureEnvironment';

export default {
  footer: {
    social: [
      {
        code: 'facebook',
        url:
          'https://www.facebook.com/groups/551215795213352/?source_id=180950569178220'
      },
      {
        code: 'twitter',
        url: 'https://twitter.com/fortellisdev'
      },
      {
        code: 'github',
        url: 'https://github.com/fortellis'
      },
      {
        code: 'youtube',
        url: 'https://www.youtube.com/channel/UCk4etySO7-MJhYCPNDtox2A'
      }
    ],

    subscribe: {
      text: 'Subscribe',
      url: 'https://www2.fortellis.io/l/149371/2024-08-12/7mj1jt'
    },

    products: [
      { text: 'API Directory', url: environmentURLs.api_reference_URL },
      {
        text: 'Developer Resources',
        url: `${
          environmentURLs.docs
        }docs/tutorials/overview/developer-tutorials-intro/`
      },
      { text: 'App Marketplace', url: environmentURLs.marketplaceURL },
      {
        text: 'Professional Services',
        url: environmentURLs.professional_services_URL
      }
    ],

    integration: [
      {
        text: 'For Dealerships',
        url: `${environmentURLs.marketplaceURL}?Ind=Automotive`
      },
      { text: 'For Software Vendors', url: environmentURLs.api_reference_URL },
      { text: 'For OEMs', url: 'https://www2.cdkglobal.com/commerce-collab' },
      {
        text: 'For Heavy Truck',
        url: `${environmentURLs.marketplaceURL}?Ind=Heavy+Truck`
      },
      {
        text: 'For Powersports',
        url: `${environmentURLs.marketplaceURL}?Ind=PowerSports`
      }
    ],

    support: [
      { text: 'Blog & Articles', url: environmentURLs.insights_URL },
      {
        text: 'CDK Global Partner Program Migration for ISVs',
        url: 'https://www2.fortellis.io/isv-migration'
      },
      {
        text: 'CDK Global Partner Program Migration for Dealers',
        url: 'https://www2.fortellis.io/isv-dealer'
      }
    ],

    company: [
      {
        text: 'About Fortellis',
        url: `${environmentURLs.fortellisURL}about-us`
      },
      { text: 'Contact Us', url: `${environmentURLs.fortellisURL}contact-us` },
      { text: 'Career Opportunities', url: 'https://careers.cdkglobal.com/' }
    ],
    copyright: {
      trademark: `©${new Date().getFullYear()}, Fortellis is a registered trademark of CDK Global, LLC.`,
      legal: {
        text: 'Privacy & Legal',
        url: '/privacy-and-legal'
      },
      terms: {
        text: 'Terms of Use',
        url: `${environmentURLs.fortellisURL}terms`
      },
      privacy: {
        text: 'Privacy Policy',
        url: `${environmentURLs.fortellisURL}privacy`
      }
    }
  }
};
